import Api from "./Api";
import { debugLog } from "../../utils/debug";

export async function savePlaylist(name, notes) {
    const curatedSongsData = JSON.parse(sessionStorage.getItem("curated-songs")).map(curatedSong => {
        return {
            playOrder: curatedSong.i,
            songId: curatedSong.songId,
            songTitle: curatedSong.songTitle,
            songBookId: curatedSong.songBookId,
            songBookTitle: curatedSong.songBookTitle,
            songBookSongNumber: curatedSong.songBookSongNumber,
            itemType: curatedSong.itemType || 'SONG',
            servicePartTitle: curatedSong.servicePartTitle || null,
            servicePartNotes: curatedSong.servicePartNotes || null,
            kstTracks: curatedSong.kstTracks || []
        }
    })

    const requestData = {
        id: JSON.parse(sessionStorage.getItem("customer")).user.id,
        name: name,
        notes: notes,
        curatedSongs: curatedSongsData
    }

    const result = Api.post(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist`, requestData)
        .then(res => {
            sessionStorage.setItem("playlist", JSON.stringify(res.data));
            return res.data;
        })
        .catch(error => {
            // Something went wrong
            if (error.response.data) {
                debugLog("Known error: " + error.response.data);
                this.setState({
                    emailError: "* ",
                    formSubmitted: false
                })
            } else {
                debugLog("Got the following error when trying to register a user: " + error.message);
            }
        });

    return result;
}

// export function updatePlaylist(playlistId, name, notes, curatedSongsData) {
//     const requestData = {
//         id: JSON.parse(sessionStorage.getItem("customer")).user.id,
//         name: name,
//         notes: notes,
//         curatedSongs: curatedSongsData
//     }
//
//     Api.put(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist/` + playlistId, requestData)
//         .then(res => {
//             sessionStorage.setItem("customer", JSON.stringify(res.data));
//         })
//         .catch(error => {
//             // Something went wrong
//             if (error.response.data) {
//                 console.log("Known error: " + error.response.data);
//                 this.setState({
//                     emailError: "* ",
//                     formSubmitted: false
//                 })
//             } else {
//                 console.log("Got the following error when trying to register a user: " + error.message);
//                 this.setState({
//                     generalError: "Something went wrong, if this persists please contact us",
//                     formSubmitted: false
//                 })
//             }
//         })
// }
export async function updatePlaylist(playlistId, name, notes, listItems) {
    try {
        const customerId = JSON.parse(sessionStorage.getItem("customer"))?.user?.id;
        if (!customerId) {
            console.error("Customer ID not found in sessionStorage");
            return false;
        }

        const curatedSongsData = listItems.map(curatedSong => {
            return {
                playOrder: curatedSong.i ? curatedSong.i : curatedSong.playOrder,
                songId: curatedSong.songId,
                songTitle: curatedSong.songTitle,
                songBookId: curatedSong.songBookId,
                songBookTitle: curatedSong.songBookTitle,
                songBookSongNumber: curatedSong.songBookSongNumber,
                itemType: curatedSong.itemType || 'SONG',
                servicePartTitle: curatedSong.servicePartTitle || null,
                servicePartNotes: curatedSong.servicePartNotes || null,
                kstTracks: curatedSong.kstTracks || []
            }
        })

        const requestData = {
            id: customerId,
            name: name,
            notes: notes,
            curatedSongs: curatedSongsData,
        };

        return await Api.put(
            `/user/${customerId}/curated-playlist/${playlistId}`,
            requestData
        ).then(res => {
            return res.status === 200 ? true : false;
        });
    } catch (error) {
        // Handle errors
        if (error.response && error.response.data) {
            debugLog("Known error: " + error.response.data);
        } else {
            debugLog("Error updating playlist: " + error.message);
        }
        return false; // Failure
    }
}

export async function emailUserPlaylist(playlistId, yourName, recipients) {
    const requestData = {
        yourName: yourName,
        recipients: recipients
    }

    return Api.post(`/share/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist/` + playlistId, requestData)
        .then(res => {
            return true;
        })
        .catch(error => {
            // Something went wrong
            debugLog("Got the following error when trying to register a user: " + error.message);
            return false;
        })
}
export async function emailPlaylist(notes, playlist, yourName, recipients) {

    const requestData = {
        yourName: yourName,
        recipients: recipients,
        playlistNotes: notes,
        playlistWords: playlist
    }

    return Api.post(`/share/curated-playlist`, requestData)
        .then(res => {
            return true;
        })
        .catch(error => {
            // Something went wrong
            debugLog("Got the following error when trying to register a user: " + error.message);
            return false;
        })
}

export async function fetchServicePlanTemplates() {
    return Api.get(`/service-plan/templates`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error fetching service plan templates: " + error.message);
            return null;
        });
}
